// extracted by mini-css-extract-plugin
export default {"wrapper":"ProfileIcons-module__wrapper","iconWrapper":"ProfileIcons-module__iconWrapper","active":"ProfileIcons-module__active","icon":"ProfileIcons-module__icon"};